import { loadYouTubeAPI } from '../utils/loadYouTubeAPI';

export default function () {
  const videoYoutubePopupCtaButtons = document.querySelectorAll('.button-videoYoutubePopup');
  const videoYoutubePopup = document.querySelector('#videoYoutubePopup');
  const btnClosePopup = document.querySelector('#btn-close-videoYoutubePopup');

  let onYouTubePlayerAPIReady = false;
  let playerYoutube = null;

  if(videoYoutubePopupCtaButtons.length <= 0 || !videoYoutubePopup) return;

  window.onYouTubePlayerAPIReady = () => {
    onYouTubePlayerAPIReady = true;
  };
  loadYouTubeAPI();

  videoYoutubePopupCtaButtons.forEach(button => {
    button.addEventListener("click", () => {
      const videoId = button.getAttribute('data-youtube-video-id');
      showModal(videoId);
    });
  });

  btnClosePopup.addEventListener('click', () => {
    playerYoutube.stopVideo();
    removeVideo();
    videoYoutubePopup.close();
  });

  function showModal(videoId) {
    document.querySelector('body').classList.add('overflow-hidden');

    videoYoutubePopup.showModal();

    playerYoutube = new YT.Player('ytplayer', {
      height: 'auto',
      width: '100%',
      videoId: videoId,
      events: {
        onReady: (event) => {
          const iframe = event.target.getIframe();
          iframe.classList.add('w-full', 'aspect-video');
          playerYoutube.playVideo();
        }
      }
    });
  }

  function removeVideo() {
    if (playerYoutube) {
      playerYoutube.destroy();
      playerYoutube = null; // Optional: set the player variable to null
    }
  }

  videoYoutubePopup.addEventListener('close', () => {
    document.querySelector('body').classList.remove('overflow-hidden');
  });
}
